import {
  PeriodEndReportFormValues,
  FullyValidatedPeriodEndReportFormValues,
} from './schema';
import { PeriodEndReport, PeriodEndReportPreview } from './types';

export const mapPeriodEndReportToFormValues = (
  periodEndReport?: PeriodEndReport,
): PeriodEndReportFormValues => ({
  useFullValidation: false,
  id: periodEndReport?.id ?? undefined,
  title: periodEndReport?.title ?? '',
  reportDate: periodEndReport?.reportDate ?? undefined,
  commentary: periodEndReport?.commentary ?? [],
  fundOverviewDatapoints: periodEndReport?.fundOverviewDatapoints ?? {
    general: {
      fundName: { included: false, value: '' },
      fundCurrency: { included: false, value: '' },
      vintageYear: { included: false, value: '' },
      displayCloseDate: { included: false, value: '' },
      totalCommitments: { included: false, value: '' },
      displayTotalCommitmentsPerClose: { included: false, value: '' },
      fundTerm: { included: false, value: '' },
      legalForm: { included: false, value: '' },
      formationJurisdiction: { included: false, value: '' },
      investmentAdviserManager: { included: false, value: '' },
      generalPartner: { included: false, value: '' },
      reinvestmentRecyclingPolicy: { included: false, value: '' },
    },
    investmentFocus: {
      stage: { included: false, value: '' },
      sector: { included: false, value: '' },
      geography: { included: false, value: '' },
    },
  },
  fundMetrics: periodEndReport?.fundMetrics ?? {
    fundValueBridge: true,
    fundValueProgression: true,
    fundPerformanceMetrics: true,
    fundCashFlowAndIrr: true,
  },
  portfolioUpdateFile: periodEndReport?.portfolioUpdateFile
    ? {
        name: periodEndReport.portfolioUpdateFile.name,
        path: periodEndReport.portfolioUpdateFile.path,
        previewUrl: periodEndReport.portfolioUpdateFile.previewUrl,
      }
    : undefined,
  notificationPreferences: periodEndReport?.notificationPreferences ?? {
    notifyViaEmail: true,
    attachPdfUpdateToEmail: true,
  },
  recipients: periodEndReport?.recipients ?? [],
  resendPublishedUpdates: false,
});

export const mapFormValuesToPeriodEndReportPreview = (
  formValues: PeriodEndReportFormValues,
): PeriodEndReportPreview => ({
  title: formValues.title ?? '',
  reportDate: formValues.reportDate,
  commentary: formValues.commentary ?? [],
  fundOverviewDatapoints: formValues.fundOverviewDatapoints,
  fundMetrics: formValues.fundMetrics,
  portfolioUpdateFile: formValues.portfolioUpdateFile,
});

export const mapFormValuesToSaveInput = (
  periodEndReport: PeriodEndReport,
  formValues: PeriodEndReportFormValues,
) => ({
  id: formValues.id ?? periodEndReport.id,
  vehicleId: periodEndReport.vehicleId,
  accountingPeriodId: periodEndReport.accountingPeriodId,
  status: periodEndReport.status,
  title: formValues.title,
  reportDate: formValues.reportDate,
  commentary: formValues.commentary,
  fundOverviewDatapoints: formValues.fundOverviewDatapoints,
  fundMetrics: formValues.fundMetrics,
  portfolioUpdateFile: formValues.portfolioUpdateFile
    ? {
        name: formValues.portfolioUpdateFile.name,
        path: formValues.portfolioUpdateFile.path,
      }
    : undefined,
  notificationPreferences: formValues.notificationPreferences,
  perInvestorNotificationSettings: formValues.recipients.map((r) => ({
    investorId: r.investorId,
    notifyViaEmail: r.notifyViaEmail,
  })),
  resendPublishedUpdates: formValues.resendPublishedUpdates,
});

export const mapFormValuesToPublishInput = (
  periodEndReport: PeriodEndReport,
  formValues: FullyValidatedPeriodEndReportFormValues,
) => ({
  ...mapFormValuesToSaveInput(periodEndReport, formValues),
  title: formValues.title,
  reportDate: formValues.reportDate,
});
